import { Form, Formik } from 'formik'
import React from 'react'

import { InputSelect } from '@/components'
import { useAlertContext } from '@/context'
import { Options } from '@/forms/CreateTicket/CreateTicket.util'
import { TicketMutations } from '@/graphql/mutations/ticket.mutations'
import { useGraphqlMutation } from '@/hooks/useGraphql'
import useTicketStatuses from '@/hooks/useTicketStatuses/useTicketStatuses'

type Props = {
  isTicketClosed: boolean
  refetchDetails: () => void
  ticketId: number
  ticketStatusId: number
}

export const TicketStatusSelection = ({ isTicketClosed, ticketStatusId, ticketId, refetchDetails }: Props) => {
  const { setAlert } = useAlertContext()

  const { data: reasonsData } = useTicketStatuses()

  const { mutate } = useGraphqlMutation(TicketMutations.updateTicket(), {
    onSuccess: () => {
      refetchDetails()
      setAlert('Ticket Status updated', 'success')
    },
  })

  let ticketStatusOptions: Options = [{ label: 'Select Status', value: '' }]
  const ticketStatuses = reasonsData && reasonsData.ticketStatuses ? reasonsData.ticketStatuses : []
  ticketStatusOptions = ticketStatuses
    .filter((ticketStatus) => ticketStatus.manualChangeAllowed)
    .map((ticketStatus) => {
      return { label: ticketStatus.internalDescription, value: ticketStatus.id }
    })

  const handleSubmit = (values: { ticketStatusId: number }) => {
    mutate({
      ticket: {
        ticketStatusId: values.ticketStatusId,
        ticketId,
      },
    })
  }

  return (
    <Formik
      initialValues={{
        ticketStatusId: ticketStatusId,
      }}
      onSubmit={handleSubmit}
    >
      {({ submitForm }) => {
        return (
          <Form className="flex w-1/2 flex-row flex-wrap">
            <InputSelect
              className="w-full"
              disabled={isTicketClosed}
              id="ticketStatusId"
              name="ticketStatusId"
              onChange={submitForm}
              options={ticketStatusOptions}
              overviewDropdown={true}
            ></InputSelect>
          </Form>
        )
      }}
    </Formik>
  )
}
